import { ELanguage } from '@/enums';
import { ILanguage } from '@/interfaces';

export const PHONE_NUMBER_REGEX = new RegExp(/^(078|073|072|079)([0-9]){7}$/);
export const NATIONAL_ID_REGEX = new RegExp(/^\d{16}$/);

export const languages: ILanguage[] = [
  {
    id: 1,
    name: 'English',
    value: ELanguage.ENGLISH
  },
  {
    id: 2,
    name: 'Kinyarwanda',
    value: ELanguage.KINYARWANDA
  },
  {
    id: 3,
    name: 'French',
    value: ELanguage.FRENCH
  }
];
